export default __webpack_public_path__ + "static/age-242b9ff66bc708158cd64ef1fc085fa9.png";